import React, { Component } from 'react';
import {TextInput, SelectInput} from './FormInputs.js';
import Modal from './Modal.js';
import CoffeeFlavorLexicon from './CoffeeFlavorLexicon.js';
import CoffeeFlavorAftertaste from './CoffeeFlavorAftertaste.js';
import CoffeeFlavorAcidity from './CoffeeFlavorAcidity.js';
import CoffeeFlavorBody from './CoffeeFlavorBody.js';
import Collapsible from './Collapsible.js';
import CoffeeNotesPane from './CoffeeNotesPane.js';
import './basicforms.css';

class SampleGradingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleSaveNotes = this.handleSaveNotes.bind(this);
    this.renderList = this.renderList.bind(this);
    this.handleChangeGrades = this.handleChangeGrades.bind(this);
  }

  handleChange(id, value) {
    this.props.handleSaveNotes(
      this.props.sampleId,
      id,
      value
    );

    /*this.setState({
      [id]:value
    });
    */
  }

  handleChangeGrades(fieldId, value) {

    this.props.handleChange(this.props.sampleId,fieldId,value);

  }

  handleCloseModal() {
    this.setState({showModal: false});
  }

  handleOpenModal(activeField, activeAttributes) {
    this.setState({
      showModal: true,
      activeField: activeField,
      activeAttributes: activeAttributes
    });
  }

  handleSaveNotes(notesState) {
    this.props.handleSaveNotes(
      this.props.sampleId,
      this.state.activeField,
      notesState
    );
    this.setState({
      //[this.state.activeField]: notesState,
      showModal: false
    });
    //console.log(this.state[this.state.activeField]);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleSubmit(this.props.sampleId);
  }

  renderList(myObject) {
    if (!myObject) {
      return('');
    }
    const coffeeNotes = Object.keys(myObject).map((item, index) => {
      if (myObject[item]) {
        return(
          <li key={index}>{item}</li>
        );
      } else {
        return('');
      }
    });
    return (
      <ul>{coffeeNotes}</ul>
    )
  }

  addScore() {
    console.log('addScore');
    console.log(this.props.formState);
    if (!this.props.formState) {
      return(0);
    }
    let gradeKeys = Object.keys(this.props.formState.grades);
    let totalScore = 0;
    for (let i = 0; i < gradeKeys.length; i++) {
      totalScore += Number(this.props.formState.grades[gradeKeys[i]]);
    }
    return (
      totalScore
    )
  }

  render() {
    const grades = [10.00,9.75,9.50,9.25,9.00,8.75,8.50,8.25,
      8.00,7.75,7.50,7.25,7.00];
    const checks = [10,8,6,4,2,0];
    //const deliveryDates = ["10-Oct-2018","10-Jan-2019"];

    return (
      //<div>Teste</div>

	<form className='basicforms' onSubmit={this.handleSubmit}>

		<div className='form_container'>
    	<h3>{this.props.name}</h3>
      <div className="row">
				<div className="col-25">
					<label>Total Score</label>
				</div>
				<div className="col-75">
          {this.addScore()}
				</div>
	    </div>

  		<div className="row">
				<div className="col-25">
					<label>Fragrance/Aroma</label>
				</div>
				<div className="col-75">
  					<SelectInput selectItems={grades} dataId="fragrance" value={this.props.formState.grades.fragrance} handleChange={this.handleChangeGrades} />
            <input type="button" value="Enter Notes" onClick={() => {this.handleOpenModal('fragranceNotes', CoffeeFlavorLexicon)}}/>
            {this.renderList(this.props.formState.notes.fragranceNotes)}

				</div>
	    </div>

			<div className="row">
				<div className="col-25">
					<label>Flavor</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="flavor" value={this.props.formState.grades.flavor} handleChange={this.handleChangeGrades}  />
          <input type="button" value="Enter Notes" onClick={() => {this.handleOpenModal('flavorNotes', CoffeeFlavorLexicon)}}/>
          {this.renderList(this.props.formState.notes.flavorNotes)}
				</div>
	    </div>
	    <div className="row">
				<div className="col-25">
					<label>Aftertaste</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="aftertaste" value={this.props.formState.grades.aftertaste} handleChange={this.handleChangeGrades}  />
          <input type="button" value="Enter Notes" onClick={() => {this.handleOpenModal('aftertasteNotes', CoffeeFlavorAftertaste)}}/>
          {this.renderList(this.props.formState.notes.aftertasteNotes)}
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Acidity</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="acidity" value={this.props.formState.grades.acidity} handleChange={this.handleChangeGrades}  />
          <input type="button" value="Enter Notes" onClick={() => {this.handleOpenModal('acidityNotes', CoffeeFlavorAcidity)}}/>
          {this.renderList(this.props.formState.notes.acidityNotes)}
        </div>
      </div>
			<div className="row">
				<div className="col-25">
					<label>Body</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="body" value={this.props.formState.grades.body} handleChange={this.handleChangeGrades}  />
          <input type="button" value="Enter Notes" onClick={() => {this.handleOpenModal('bodyNotes', CoffeeFlavorBody)}}/>
          {this.renderList(this.props.formState.notes.bodyNotes)}
				</div>
	    </div>
			<div className="row">
				<div className="col-25">
					<label>Balance</label>
				</div>
				<div className="col-75">
		        <SelectInput selectItems={grades} dataId="balance" value={this.props.formState.grades.balance} handleChange={this.handleChangeGrades}  />
				</div>
	    </div>
			<div className="row">
				<div className="col-25">
					<label>Overall</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={grades} dataId="overall" value={this.props.formState.grades.overall} handleChange={this.handleChangeGrades}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Uniformity</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="uniformity" value={this.props.formState.grades.uniformity} handleChange={this.handleChangeGrades}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Clean Cup</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="cleanCup" value={this.props.formState.grades.cleanCup} handleChange={this.handleChangeGrades}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Sweetness</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={checks} dataId="sweetness" value={this.props.formState.grades.sweetness} handleChange={this.handleChangeGrades}  />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Defects</label>
				</div>
				<div className="col-75">
					<TextInput type="number" dataId="defects"  value={this.props.formState.grades.defects} handleChange={this.handleChangeGrades} />
				</div>
	    </div>
  		<div className="row">
				<div className="col-25">
					<label>Observations</label>
				</div>
				<div className="col-75">
					<TextInput type="text" dataId="obs" value={this.props.formState.notes.obs} handleChange={this.handleChange} />
				</div>
	    </div>


  		<div className="row">
  			<div className="col-100">
  				<input type="submit" value="Submit"/>
  			</div>
	    </div>

      <div>
        <Modal
          handleClose={this.handleCloseModal}
          showModal={this.state.showModal}
        >
          <h3>Cupping Notes</h3>
          <CoffeeNotesPane
            myTree={this.state.activeAttributes}
            saveNotes={this.handleSaveNotes}
          />
        </Modal>
      </div>


		</div>

  </form>

    );
  }
}

export default SampleGradingForm;



// WEBPACK FOOTER //
// ./src/components/SampleGradingForm.js